<template lang="pug">
  .note-item
    v-card.border-bottom(flat style="border-radius:0px")
      v-row.pl-5.pr-2(no-gutters)
        v-col.py-3
          .p1.basic800--text {{ note.name }}
          .c1.basic600--text.mt-1(v-if="note.short_text") {{ note.short_text }}
          .c2.basic600--text.mt-1 {{ $tc('assigned_products', note.product_count) }}

        v-col.shrink.py-3.pr-1(v-if="member.role === 'Admin'")
          div
            y-switch(v-model="note.enabled")
          div.d-flex.justify-end.align-end
            v-menu(left offset-x)
              template(v-slot:activator='{ on }')
                v-btn(icon color="transparent" v-on='on' small)
                  v-icon(color="basic700") mdi-dots-vertical
              v-list.pa-0
                v-list-item.border-bottom(@click="clickEdit")
                  v-list-item-content
                    v-list-item-title.s2.basic800--text {{ $t('edit') }}
                //- v-list-item.border-bottom(
                //-   @click="clickDuplicate"
                //- )
                //-   v-list-item-content
                //-     v-list-item-title.s2.basic800--text Duplicate
                v-list-item.border-bottom(@click="clickDelete")
                  v-list-item-content
                    v-list-item-title.s2.basic800--text() {{ $t('delete') }}

    .modals
      add-product-notes(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :parentNote.sync="note" :company="company")
      y-dialog(v-model='openDeleteDialog', max-width='290' persistent)
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_note') }}
          v-card-text.p2.primary500--text.px-4
            | {{ $t('delete_note_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white' text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn(color='danger500' depressed dark @click='startDelete' :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex'
import AddProductNotes from '@/components/productnotes/dialogs/AddProductNotes.vue'

export default {
  name: 'ProductNotesItem',
  props: ['parentNote'],
  components: { AddProductNotes },
  data: () => ({
    showAddProductDialog: false,
    openDeleteDialog: false,
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    note: {
      get() {
        return this.parentNote
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    }
  },
  watch: {
    'note.enabled' (val) {
      this.updateNoteStatus(val)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickEdit () {
      this.showAddProductDialog = true
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.isLoading = true
      this.axios.delete(`/product_notes/${this.note.id}/`)
        .then(() => {
          this.$emit('deleted', this.note)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateNoteStatus (val) {
      this.$axios.patch(`/product_notes/${this.note.id}/`, { enabled: val })
        .then(() => {
          this.showMessage(['success', `Note ${val ? 'enabled' : 'disabled'}`])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.border-bottom{
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
.count-layout {
  position: absolute;
  right: 10px;
  top: 6px;
}
.product-title {
  font-size: 16px;
  font-weight: bold;
  height: 2.8em; 
  line-height: 1.4em; 
  overflow: hidden;
}
.product-description {
  font-size: 12px;
  height: 3.3em; 
  text-overflow: ellipsis; 
  line-height: 1.1em; 
  white-space: pre-wrap;
  overflow: hidden;
}
.product-price {
  font-size: 16px;
  font-weight: bold;
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "assigned_products" : "Not assigned | Assigned to {n} product | Assigned to {n} products",
    "delete_note": "Delete note",
    "delete_note_confirmation": "Are you sure you want to delete this item? This item will be deleted permanently."
  },
  "id": {
     "assigned_products" : "Tidak ditetapkan | Ditetapkan pada {n} produk | Ditetapkan pada {n} produk",
    "delete_note": "Hapus nota",
    "delete_note_confirmation": "Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen."
  }
}
</i18n>